import { apiClient } from './client';
import type { Menu } from '@/types/models/menu';

export type { Menu };

/**
 * 菜单管理 API
 */
export const menuApi = {
  /**
   * 获取菜单树
   */
  getTree: () => {
    return apiClient.get<{ data: Menu[] }>('/v1/system/menus/tree');
  },

  /**
   * 获取用户菜单路由
   */
  getRoutes: () => {
    return apiClient.get<{ data: Menu[] }>('/v1/system/menus/routes');
  },

  /**
   * 获取菜单列表 (扁平)
   */
  getList: (params?: { menu_type?: string }) => {
    return apiClient.get<{ data: Menu[] }>('/v1/system/menus', { params });
  },

  /**
   * 获取菜单详情
   */
  getDetail: (id: number) => {
    return apiClient.get<Menu>(`/v1/system/menus/${id}`);
  },

  /**
   * 创建菜单
   */
  create: (data: Partial<Menu>) => {
    return apiClient.post<{ data: any }>('/v1/system/menus', data);
  },

  /**
   * 更新菜单
   */
  update: (id: number, data: Partial<Menu>) => {
    return apiClient.put<{ data: any }>(`/v1/system/menus/${id}`, data);
  },

  /**
   * 删除菜单
   */
  delete: (id: number) => {
    return apiClient.delete<{ data: any }>(`/v1/system/menus/${id}`);
  },
};

// 兼容旧导出
export const getMenuTree = async (): Promise<{ data: Menu[] }> => {
  try {
    const response = await menuApi.getTree();
    return { data: response.data || [] };
  } catch (error) {
    console.error('获取菜单树失败:', error);
    return { data: [] };
  }
};

export const getUserMenus = async (): Promise<{ data: Menu[] }> => {
  try {
    const response = await menuApi.getRoutes();
    return { data: response.data || [] };
  } catch (error) {
    console.error('获取用户菜单失败:', error);
    return { data: [] };
  }
};

export const getMenuList = async (params?: { menu_type?: string }): Promise<{ data: Menu[] }> => {
  try {
    const response = await menuApi.getList(params);
    return { data: response.data || [] };
  } catch (error) {
    console.error('获取菜单列表失败:', error);
    return { data: [] };
  }
};

export const getMenu = async (id: number): Promise<{ data: Menu | null }> => {
  try {
    const response = await menuApi.getDetail(id);
    return { data: response.data };
  } catch (error) {
    console.error('获取菜单详情失败:', error);
    return { data: null };
  }
};

export const createMenu = async (data: Partial<Menu>): Promise<{ data: any }> => {
  const response = await menuApi.create(data);
  return { data: response.data };
};

export const updateMenu = async (id: number, data: Partial<Menu>): Promise<{ data: any }> => {
  const response = await menuApi.update(id, data);
  return { data: response.data };
};

export const deleteMenu = async (id: number): Promise<{ data: any }> => {
  const response = await menuApi.delete(id);
  return { data: response.data };
};
